<ng-template let-notif="data">
  <div class="notification-container" (click)="notif.onClick($event, notif)">
    <div class="icon-wrapper" *ngIf="notif.type === 'success'">
      <va-icon name="check-circle" class="fa-lg success-icon"></va-icon>
    </div>
    <div class="icon-wrapper" *ngIf="notif.type === 'error'">
      <va-icon [name]="faExclamationCircle" [isFontAwesome]="true" class="fa-lg err-icon"></va-icon>
    </div>
    <div class="icon-wrapper" *ngIf="notif.type === 'warning'">
      <va-icon
        [name]="faExclamationCircle"
        [isFontAwesome]="true" 
        class="fa-lg warning-icon"
      ></va-icon>
    </div>
    <div class="icon-wrapper" *ngIf="notif.type === 'info'">
      <va-icon name="info-circle" class="fa-lg info-icon"></va-icon>
    </div>
    <div class="msg-container">
      <div class="title">{{ notif.title }}</div>
      <div [innerHtml]="notif.msg"></div>
    </div>
  </div>
</ng-template>
